export default __webpack_public_path__ + "static/media/mufasa_baby.317fddfd.jpg";